document.addEventListener("DOMContentLoaded", function () {
  let quesAdded = {};

  function updateMilestoneProgress() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        const total = cart.total_price / 100;
        const steps = document.querySelectorAll(".milestone-step");
        const message = document.getElementById("milestoneMessage");
        const labels = document.querySelectorAll(".milestone-labels span");
        const cartVariantIds = cart.items.map((item) => item.variant_id);

        let nextStep = null;
        let nextReward = null;

        steps.forEach((step, i) => {
          const milestone = parseFloat(step.dataset.step) / 100;
          const variantId = step.dataset.variant;
          const isQualified = total >= milestone;

          const fillElement = document.querySelector("#milestoneBarFill");
          if (fillElement) {
            const percent = Math.min((total / milestone) * 100, 100);
            fillElement.style.width = percent + "%";
          }

          if (isQualified) {
            step.classList.add("active");
            if (
              !quesAdded[variantId] &&
              variantId &&
              !cartVariantIds.includes(Number(variantId))
            ) {
              quesAdded[`${variantId}`] = true;
              fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  id: variantId,
                  quantity: 1,
                  properties: { __addon: true },
                }),
              })
                .then(() => {
                  document.dispatchEvent(new Event("cart:refresh"));
                })
                .catch((err) =>
                  console.error(`Failed to add variant ${variantId}`, err)
                );
            }
          } else {
            step.classList.remove("active");
            if (!nextStep) {
              nextStep = milestone;
              nextReward = labels[i]?.textContent;
            }
            if (variantId && cartVariantIds.includes(Number(variantId))) {
              if (quesAdded[`${variantId}`]) delete quesAdded[`${variantId}`];
              const cartItem = cart.items.find(
                (item) => item.variant_id === Number(variantId)
              );
              if (cartItem) {
                fetch("/cart/change.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ id: cartItem.key, quantity: 0 }),
                })
                  .then(() => {
                    document.dispatchEvent(new Event("cart:refresh"));
                  })
                  .catch((err) =>
                    console.error(`Failed to remove variant ${variantId}`, err)
                  );
              }
            }
          }
        });

        if (message) {
          if (!nextStep) {
            message.innerHTML = `<strong>🎉 You've unlocked FREE Shipping!</strong>`;
          } else {
            const remaining = (nextStep - total).toFixed(2);
            message.innerHTML = `Spend <strong>$${remaining} AUD</strong> more to reach <strong>${nextReward}</strong>.`;
          }
        }
      })
      .catch((error) => {
        console.error("Failed to fetch cart data:", error);
      });
  }

  window.updateMilestoneProgress = updateMilestoneProgress;

  document.addEventListener("cart:updated", updateMilestoneProgress);

  updateMilestoneProgress();
});
